import React from 'react';

import { CheckCircleIcon, CrossCircleIcon } from '@vlabs/icons';

import './ProgressCell.sass';

const ProgressCell = (status) => (
  <div className="ProgressCell">
    {status === 'error' && <CrossCircleIcon className="ProgressCell_canceled" />}
    {status === 'done' && <CheckCircleIcon className="ProgressCell_finished" />}
  </div>
);

export default ProgressCell;
